<template>
    <div class="row justify-content-center">
        <div class="col-xl-9 col-lg-10 col-md-12 col-sm-12">
            <div class="reviews-slide px-3">
                <div v-for="(item, index) in clientData" :key="index" class="single_review">
                    <div class="sng_rev_thumb"><figure><img :src="item.image" class="img-fluid circle" alt="" /></figure></div>
                    <div class="sng_rev_caption text-center">
                        <div class="rev_desc mb-4">
                            <p class="fs-md">{{item.desc}}</p>
                        </div>
                        <div class="rev_author">
                            <h3 class="mb-0">{{item.name}}</h3>
                            <span class="fs-sm">{{item.position}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { clientData } from '@/data/data';

    import { tns } from "tiny-slider/src/tiny-slider";
    import { onMounted } from 'vue';

    onMounted(() => {
        tns({
            container: ".reviews-slide",
            items: 1,
            controls: false,
            mouseDrag: true,
            loop: true,
            rewind: true,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayTimeout: 3000,
            navPosition: "bottom",
            speed: 400,
            gutter: 16,
            nav:true,
         });
    });
</script>
